import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-configuracion-riesgo',
  templateUrl: './configuracion-riesgo.component.html',
  styleUrls: ['./configuracion-riesgo.component.scss']
})
export class ConfiguracionRiesgoComponent{

  constructor(private loginService:LoginService) { }

  clickGuard() {
    this.loginService.clickGuard = true;
  }
}
